import { render } from "./CategoryHeader.vue?vue&type=template&id=668a5cde"
import script from "./CategoryHeader.vue?vue&type=script&lang=js"
export * from "./CategoryHeader.vue?vue&type=script&lang=js"

import "./CategoryHeader.vue?vue&type=style&index=0&id=668a5cde&lang=scss"

import exportComponent from "C:\\Users\\30822\\Desktop\\LQ\\git\\度才子\\supplier_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__